export default __webpack_public_path__ + "static/media/price-bg.b3c4bae6.png";